<vb-panel-header title="My invoices">
    <div panelActions>
        <vb-search-input
            placeholder="Enter invoice number…"
            ariaLabel="Search invoices by number"
            [value]="searchText ?? ''"
            (valueChange)="onSearchChange($event)">
        </vb-search-input>
    </div>
</vb-panel-header>

<!-- Top pagination lockup — summary + per-page 10/25/50 + nav, mirroring
     the My-bidding panel. -->
<vb-paginator-bar
    *ngIf="!isLoading && rows.length > 0"
    class="inv-panel__topbar"
    variant="top"
    label="invoices"
    [dense]="isMobile"
    [current]="paginate.currentPage || 1"
    [total]="paginate.totalPages || 0"
    [totalItems]="paginate.totalItems || 0"
    [perPage]="pageSize"
    [perPageOptions]="pageSizeOptions"
    (pageChange)="setPage($event)"
    (perPageChange)="setPageSize($event)">
</vb-paginator-bar>

<vb-invoice-table
    *ngIf="!isLoading && rows.length > 0"
    class="inv-panel__table"
    [rows]="rows"
    (rowClick)="onTableRow($event)"
    (actionClick)="onTableAction($event)">
</vb-invoice-table>

<div *ngIf="!isLoading && rows.length === 0" class="inv-panel__empty">
    No data to show at the moment.
</div>

<div *ngIf="isLoading" class="vb-spinner-box vb-spinner-box--panel">
    <vb-spinner size="xl" label="Loading invoices"></vb-spinner>
</div>

<!-- Footer: legend left, bare pager right (per-page lives in the top bar) -->
<footer class="inv-panel__footer" *ngIf="!isLoading && rows.length > 0">
    <vb-legend [items]="legendItems"></vb-legend>
    <vb-paginator
        [current]="paginate.currentPage || 1"
        [total]="paginate.totalPages || 0"
        [labels]="false"
        [dense]="isMobile"
        (pageChange)="setPage($event)">
    </vb-paginator>
</footer>
